// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1BRdA","checkboxCol":"Table_checkboxCol__1FW71","emailCol":"Table_emailCol__34Bx_","actionCol":"Table_actionCol__13Sgz"};